import { useEffect } from "react";
import api, { publicFileUrl } from "@/lib/api";

function setMeta(name, content) {
  if (content == null) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setFavicon(href) {
  let el = document.querySelector("link[rel='icon']");
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "icon");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href || "/favicon.ico");
}

// Applies admin-managed SEO (page title, description, keywords, favicon) at runtime.
export default function SeoHead() {
  useEffect(() => {
    api.get("/public-settings").then((r) => {
      const s = r.data || {};
      const title = s.seo_title || s.brand_name || "Startup Agency";
      document.title = title;
      setMeta("description", s.seo_description || "");
      if (s.seo_keywords) setMeta("keywords", s.seo_keywords);
      setFavicon(s.favicon ? publicFileUrl(s.favicon, s.branding_rev) : "");
    }).catch(() => {});
  }, []);
  return null;
}
